// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Light polish of the access forms (login, password reset/request, account creation) that keeps
 * their original layout: outlined fields like the other forms, more breathing room
 * and clearer buttons. Use it with @include auth-polish.form; at the END of the form
 * stylesheet, so it wins over the older rules. */
/* Page around the forms: slightly narrower column and a more compact logo */
ion-checkbox {
  margin-left: 0;
}

ion-button {
  width: 100%;
}

ion-icon {
  height: 15px;
  font-size: 16px;
  vertical-align: middle;
}

.item-remember-me {
  margin-top: 9px;
}

.item-auto-access {
  margin-bottom: 9px;
}

.checkbox-in-list,
.checkbox-label {
  margin-top: 0;
  margin-bottom: 0;
}

.item-checkbox {
  --ripple-color: transparent;
  --background-hover: var(--background);
  --min-height: 35px;
}

.button-login {
  --box-shadow: none;
  --border-radius: 10px;
}

.button-account {
  --box-shadow: none;
  --background: white;
  color: var(--ion-color-primary);
  border: 1px solid var(--ion-color-primary) !important;
  border-radius: 10px;
}

.label-forgot-password {
  cursor: pointer;
}

.button-go-back {
  background-color: white;
  border: 1px solid var(--ion-color-primary);
  border-radius: 10px;
  color: var(--ion-color-primary);
}

.formRequestPWD {
  margin-bottom: 20px;
}

.titleLbl {
  text-align: justify;
  font-size: 18px;
  font-weight: 600;
}

.descriptionlbl {
  text-align: justify;
}

.container-access-login {
  padding-bottom: var(--ion-safe-area-bottom);
}

/* Light polish keeping the original look (kept last so it wins over the rules above) */
/* Fields: outlined and rounded like the other forms, primary ring when focused */
ion-input[fill=outline],
ion-select[fill=outline] {
  --border-radius: 10px;
  --border-color: rgba(var(--ion-color-medium-rgb), 0.4);
  --highlight-color-focused: var(--ion-color-primary);
  --background: var(--ion-background-color, #fff);
  min-height: 56px;
  margin-bottom: 14px;
}

/* Title / description of the forms */
.titleLbl {
  font-size: 20px;
  font-weight: 700;
  text-align: left;
}

.descriptionlbl {
  font-size: 14px;
  line-height: 1.5;
  text-align: left;
  color: var(--ion-color-medium-shade);
}

/* "Forgot password?": on the right, under the password */
ion-item:has(.label-forgot-password) {
  --background: transparent;
  --padding-start: 0;
  --inner-padding-end: 0;
  margin-top: -6px;
  text-align: right;
}

.label-forgot-password {
  font-size: 14px;
  font-weight: 600;
}

/* Primary action */
.button-login {
  height: 50px;
  margin-top: 12px;
  --border-radius: 10px;
  --box-shadow: none;
  font-weight: 600;
  letter-spacing: 0.5px;
}

/* Secondary actions (create account, go back): outlined, same size */
.button-account,
.button-go-back {
  height: 50px;
  margin-top: 10px;
  border: 1px solid rgba(var(--ion-color-primary-rgb), 0.5) !important;
  border-radius: 10px !important;
  --border-radius: 10px;
  font-weight: 600;
  letter-spacing: 0.5px;
  transition: background-color 0.15s ease;
}
.button-account:hover,
.button-go-back:hover {
  background-color: rgba(var(--ion-color-primary-rgb), 0.06) !important;
}`, "",{"version":3,"sources":["webpack://./src/theme/_auth-polish.scss","webpack://./src/components/form-components/form-request-change-pwd/form-request-change-pwd.component.scss"],"names":[],"mappings":"AAAA;;;iDAAA;AAyEA,4EAAA;ACvEA;EACE,cAAA;AAIF;;AADA;EACE,WAAA;AAIF;;AADA;EACE,YAAA;EACA,eAAA;EACA,sBAAA;AAIF;;AADA;EACE,eAAA;AAIF;;AADA;EACE,kBAAA;AAIF;;AAAA;;EAEE,aAAA;EACA,gBAAA;AAGF;;AAAA;EACE,2BAAA;EACA,qCAAA;EACA,kBAAA;AAGF;;AAAA;EACE,kBAAA;EACA,qBAAA;AAGF;;AAAA;EACE,kBAAA;EACA,mBAAA;EACA,+BAAA;EACA,qDAAA;EACA,mBAAA;AAGF;;AAAA;EACE,eAAA;AAGF;;AAAA;EACE,uBAAA;EACA,0CAAA;EACA,mBAAA;EACA,+BAAA;AAGF;;AAAA;EACE,mBAAA;AAGF;;AAAA;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;AAGF;;AAAA;EACE,mBAAA;AAGF;;AAAA;EACE,2CAAA;AAGF;;AAAA,uFAAA;ADzEE,iFAAA;AACA;;EAEE,qBAAA;EACA,sDAAA;EACA,mDAAA;EACA,+CAAA;EACA,gBAAA;EACA,mBAAA;AC6EJ;;AD1EE,qCAAA;AACA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AC6EJ;;AD1EE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,oCAAA;AC6EJ;;AD1EE,yDAAA;AACA;EACE,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;AC6EJ;;AD1EE;EACE,eAAA;EACA,gBAAA;AC6EJ;;AD1EE,mBAAA;AACA;EACE,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AC6EJ;;AD1EE,qEAAA;AACA;;EAEE,YAAA;EACA,gBAAA;EACA,oEAAA;EACA,8BAAA;EACA,qBAAA;EACA,gBAAA;EACA,qBAAA;EACA,uCAAA;AC6EJ;AD3EI;;EACE,qEAAA;AC8EN","sourcesContent":["/* Light polish of the access forms (login, password reset/request, account creation) that keeps\n * their original layout: outlined fields like the other forms, more breathing room\n * and clearer buttons. Use it with @include auth-polish.form; at the END of the form\n * stylesheet, so it wins over the older rules. */\n\n@mixin form {\n  /* Fields: outlined and rounded like the other forms, primary ring when focused */\n  ion-input[fill=\"outline\"],\n  ion-select[fill=\"outline\"] {\n    --border-radius: 10px;\n    --border-color: rgba(var(--ion-color-medium-rgb), 0.4);\n    --highlight-color-focused: var(--ion-color-primary);\n    --background: var(--ion-background-color, #fff);\n    min-height: 56px;\n    margin-bottom: 14px;\n  }\n\n  /* Title / description of the forms */\n  .titleLbl {\n    font-size: 20px;\n    font-weight: 700;\n    text-align: left;\n  }\n\n  .descriptionlbl {\n    font-size: 14px;\n    line-height: 1.5;\n    text-align: left;\n    color: var(--ion-color-medium-shade);\n  }\n\n  /* \"Forgot password?\": on the right, under the password */\n  ion-item:has(.label-forgot-password) {\n    --background: transparent;\n    --padding-start: 0;\n    --inner-padding-end: 0;\n    margin-top: -6px;\n    text-align: right;\n  }\n\n  .label-forgot-password {\n    font-size: 14px;\n    font-weight: 600;\n  }\n\n  /* Primary action */\n  .button-login {\n    height: 50px;\n    margin-top: 12px;\n    --border-radius: 10px;\n    --box-shadow: none;\n    font-weight: 600;\n    letter-spacing: 0.5px;\n  }\n\n  /* Secondary actions (create account, go back): outlined, same size */\n  .button-account,\n  .button-go-back {\n    height: 50px;\n    margin-top: 10px;\n    border: 1px solid rgba(var(--ion-color-primary-rgb), 0.5) !important;\n    border-radius: 10px !important;\n    --border-radius: 10px;\n    font-weight: 600;\n    letter-spacing: 0.5px;\n    transition: background-color 0.15s ease;\n\n    &:hover {\n      background-color: rgba(var(--ion-color-primary-rgb), 0.06) !important;\n    }\n  }\n}\n\n/* Page around the forms: slightly narrower column and a more compact logo */\n@mixin page {\n  .content-login {\n    width: min(100%, 520px);\n  }\n\n  .container-logo-login img {\n    max-height: 180px;\n    margin-block-end: 32px;\n  }\n}\n","@use \"../../../theme/auth-polish\";\n\nion-checkbox {\n  margin-left: 0;\n}\n\nion-button {\n  width: 100%;\n}\n\nion-icon {\n  height: 15px;\n  font-size: 16px;\n  vertical-align: middle;\n}\n\n.item-remember-me {\n  margin-top: 9px;\n}\n\n.item-auto-access {\n  margin-bottom: 9px;\n}\n\n\n.checkbox-in-list,\n.checkbox-label {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.item-checkbox {\n  --ripple-color: transparent;\n  --background-hover: var(--background);\n  --min-height: 35px;\n}\n\n.button-login {\n  --box-shadow: none;\n  --border-radius: 10px;\n}\n\n.button-account {\n  --box-shadow: none;\n  --background: white;\n  color: var(--ion-color-primary);\n  border: 1px solid var(--ion-color-primary) !important;\n  border-radius: 10px;\n}\n\n.label-forgot-password {\n  cursor: pointer\n}\n\n.button-go-back {\n  background-color: white;\n  border: 1px solid var(--ion-color-primary);\n  border-radius: 10px;\n  color: var(--ion-color-primary);\n}\n\n.formRequestPWD {\n  margin-bottom: 20px;\n}\n\n.titleLbl {\n  text-align: justify;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.descriptionlbl {\n  text-align: justify;\n}\n\n.container-access-login {\n  padding-bottom: var(--ion-safe-area-bottom);\n}\n\n/* Light polish keeping the original look (kept last so it wins over the rules above) */\n@include auth-polish.form;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
